import styled from '@emotion/styled';
import React from 'react';

import quoteUrl from '@assets/svg/quote.svg';
import { getFont } from '@styles/mixins/fonts';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

interface TextBlockWithQuotesProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  quote: string;
  author: string;
}

export const TextBlockWithQuotes = React.forwardRef<HTMLDivElement, TextBlockWithQuotesProps>(
  ({ quote, author, className }, blockRef) => {
    return (
      <Wrapper className={className} ref={blockRef}>
        <Quote>{quote}</Quote>
        <Author>{author}</Author>
      </Wrapper>
    );
  },
);

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: fit-content;
  padding-top: 70px;
  width: 510px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 73px;
    height: 50px;
    background-image: url(${quoteUrl});
    background-repeat: no-repeat;
    background-size: contain;
  }

  ${getMediaqueryStyled('xl')} {
    padding-top: 57px;
    width: 405px;

    &::before {
      width: 61px;
      height: 42px;
    }
  }

  ${getMediaqueryStyled('lg')} {
    padding-top: 35px;
    width: 265px;

    &::before {
      width: 37px;
      height: 25px;
    }
  }

  ${getMediaqueryStyled('md')} {
    width: 100%;
  }
`;

const Quote = styled.q`
  margin-bottom: 24px;
  ${getFont('side')}

  &::before,
  &::after {
    display: none;
  }

  ${getMediaqueryStyled('xl')} {
    margin-bottom: 12px;
  }
`;

const Author = styled.cite`
  ${getFont('side')}
`;
